<template>
        <div class="footer3">
                <!-- Footer -->
                <footer class="footer container-fluid pl-30 pr-30"></footer>
                <!-- /Footer -->
        </div>
</template>



<script>

export default {
}
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/AppFooter.vue